import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import GlobalContext from './context/'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import {RecoilRoot} from 'recoil';

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <GlobalContext>
        <App />
      </GlobalContext>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();
